import { MessageSquare } from 'lucide-react';

const BilansMensuelsSection = ({ bilansEntreprise }) => {
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-6 shadow-sm" data-testid="bilans-mensuels-centre">
      <h2 className="text-xl font-display font-semibold text-[#0F172A] mb-4 flex items-center gap-2">
        <MessageSquare className="h-5 w-5 text-orange-500" />
        Bilans Mensuels de l'Entreprise
        <span className="text-sm font-normal text-slate-500">({bilansEntreprise.length})</span>
      </h2>
      {bilansEntreprise.length === 0 ? (
        <div className="text-center py-8 bg-slate-50 rounded-lg">
          <MessageSquare className="h-12 w-12 text-slate-300 mx-auto mb-3" />
          <p className="text-slate-500">Aucun bilan mensuel soumis par l'entreprise</p>
          <p className="text-xs text-slate-400 mt-1">Les bilans apparaîtront ici lorsque l'entreprise les aura renseignés</p>
        </div>
      ) : (
        <div className="space-y-4">
          {bilansEntreprise.sort((a, b) => new Date(b.date) - new Date(a.date)).map((bilan, idx) => (
            <div key={idx} className="p-4 bg-orange-50 rounded-lg border border-orange-200">
              <div className="flex items-center justify-between mb-3">
                <span className="font-medium text-orange-800 capitalize">Bilan {bilan.mois} {bilan.annee}</span>
                <span className="text-xs text-slate-500">
                  {new Date(bilan.date).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })}
                </span>
              </div>
              {bilan.contenu && (
                <div className="bg-white p-3 rounded border-l-4 border-orange-400">
                  <p className="text-sm text-slate-700 whitespace-pre-wrap">{bilan.contenu}</p>
                </div>
              )}
              {bilan.satisfaction && (
                <div className="mt-3">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                    bilan.satisfaction === 'tres_satisfait' ? 'bg-green-100 text-green-700' :
                    bilan.satisfaction === 'satisfait' ? 'bg-blue-100 text-blue-700' :
                    bilan.satisfaction === 'peu_satisfait' ? 'bg-orange-100 text-orange-700' :
                    'bg-red-100 text-red-700'
                  }`}>
                    {bilan.satisfaction === 'tres_satisfait' ? 'Très satisfait' :
                     bilan.satisfaction === 'satisfait' ? 'Satisfait' :
                     bilan.satisfaction === 'peu_satisfait' ? 'Peu satisfait' :
                     'Non satisfait'}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BilansMensuelsSection;
